import {
    convertMapToList,
    DEFAULT_STATUS_KEY,
    EntityStatusInfo,
    StatusInfo,
} from 'src/components/EntityStatusInfo/EntityStatusInfo';
import { Campaign, LoanProduct } from 'src/generated-api-client';
import { CssColors } from 'src/styles/CssVariables';

type ProductStatusProps = { item: LoanProduct | Campaign };

export const ProductStatus = ({ item }: ProductStatusProps) => {
    return (
        <EntityStatusInfo
            statusInfoMap={productsStatusInfoMap}
            status={getProductStatus(item)}
            entityName="product"
        />
    );
};

const getProductStatus = (product?: LoanProduct | Campaign) => {
    return product?.active ? 'ACTIVE' : 'INACTIVE';
};

const productsStatusInfoMap: Record<string, StatusInfo> = {
    ACTIVE: {
        color: CssColors.mainGreen,
        borderColor: CssColors.mainGreen,
        title: 'Active',
        backgroundColor: CssColors.mainGreen,
    },
    INACTIVE: {
        color: CssColors.mainRed,
        borderColor: CssColors.mainRed,
        title: 'Inactive',
        backgroundColor: CssColors.mainRed,
    },
    [DEFAULT_STATUS_KEY]: {
        color: '#91796c',
        borderColor: '#F4F0DF',
        title: 'Invalid status',
        backgroundColor: '#F4F0DF',
    },
};

export const getCollectionStatuses = () => {
    return convertMapToList(productsStatusInfoMap);
};
